//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
//------------------------------------------------------------------------------
// Style -----------------------------------------------------------------------
import styles from './index.module.scss';
// import styles from '../../../../../../../App.scss';
// import * as styles from '../'
// import * from '../'
//------------------------------------------------------------------------------
// My Components ---------------------------------------------------------------
import { Button, ButtonStyle } from '@cmp/common';
//------------------------------------------------------------------------------
// Assets ----------------------------------------------------------------------
import { MinusIcon, PlusIcon, TrashIcon } from '@cmp/images';
//------------------------------------------------------------------------------
// Helpers & Constants ---------------------------------------------------------
import { shopifyFormatter, currencyFormatter } from '@helpers/formatter';
import { StoreConfigContext } from '@helpers/storeConfigContext';
import { withTranslation } from 'react-i18next';
import { handleGtmEvent } from '@helpers/gtm';

//------------------------------------------------------------------------------
// React Class -----------------------------------------------------------------
class Products extends React.Component {
  isEditingProduct(product) {
    const { editingProducts } = this.props;
    return (
      editingProducts &&
      editingProducts.findIndex((x) => x.id === product.id) > -1
    );
  }

  stepperComponent(product, { disabled, metadata }) {
    const { onEditProduct, editingProducts, t } = this.props;
    const { quantityRecommended } = product;

    const quantity = [1, 2, 3, 4, 5];

    const componentClasses = classNames(
      styles.Stepper,
      styles.RecommendationSafariSelect,
      {
        [styles.Disabled]: disabled,
      }
    );

    return (
      <div className={componentClasses}>
        <select
          className={classNames(styles.QuantitySelect)}
          disabled={disabled}
          onChange={(e) => {
            const targetValue = parseInt(e.target.value);
            !disabled && onEditProduct(product, targetValue);

            const eventType =
              targetValue > quantityRecommended
                ? 'add_to_cart'
                : 'remove_from_cart';

            product.delta = Math.abs(quantityRecommended - targetValue);
            handleGtmEvent(eventType, {
              context: this.context,
              products: [product],
              metadata,
            });
          }}
          value={quantityRecommended}
        >
          {quantity.map((q, index) => (
            <option key={`quantity-${index}`} value={q}>
              {q}
            </option>
          ))}
        </select>
        <svg
          className="safari-visible"
          height="20"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill="currentColor"
            d="M17.68 9.31c.42.42.42 1.1.02 1.5l-4.94 4.88c-.42.41-1.1.41-1.51 0L6.3 10.8a1.05 1.05 0 0 1 0-1.5c.42-.41 1.1-.41 1.52 0L12 13.44l4.17-4.13c.42-.41 1.1-.41 1.51 0z"
          ></path>
        </svg>
        <span
          className={classNames(
            styles.QuantityUnit,
            styles.RecommendationSafariLabel
          )}
        >
          {t('dashboard_Qty')}
        </span>
      </div>
    );
  }

  quantityComponent(
    quantityPurchased,
    quantityRecommended,
    editable,
    disabled
  ) {
    const { t } = this.props;
    if (editable) return '';
    if (disabled) {
      return (
        <span className={styles.Amount}>
          {t('dashboard_Quantity')}
          <br />
          {quantityRecommended - quantityPurchased}
        </span>
      );
    } else {
      return (
        <span className={styles.Amount}>
          {t('dashboard_Quantity')}:{' '}
          {quantityPurchased ? quantityPurchased : quantityRecommended}
        </span>
      );
    }
  }

  singleProductComponent = (product, editable, disabled) => {
    const { onEditProduct, t, i18n } = this.props;
    const {
      id,
      productName,
      quantityPurchased,
      editingProducts,
      quantityRecommended,
      fullPrice,
      discountedPrice,
    } = product;
    const productname = product.productName.replace('<br>', ' ');

    const formattedProduct = shopifyFormatter.product(product);
    const defaultImage = formattedProduct.defaultImage(i18n);
    const isEditing = this.isEditingProduct(product);

    const componentClasses = classNames(styles.SingleProduct, {
      [styles.Disabled]: disabled,
    });

    const removeClasses = classNames(styles.Remove, {
      [styles.Disabled]: isEditing,
    });

    const trimmedFullPrice = currencyFormatter.trimmedPrice(fullPrice);
    const trimmedDiscountedPrice =
      currencyFormatter.trimmedPrice(discountedPrice);
    const hasDiscount =
      trimmedDiscountedPrice &&
      fullPrice &&
      +fullPrice !== 0 &&
      trimmedFullPrice !== trimmedDiscountedPrice;

    const brand = t('header_title');
    const metadata = { brand };
    return (
      <div className={componentClasses} key={id}>
        <img
          alt={productName}
          src={defaultImage && defaultImage.src}
          className={styles.Image}
        />
        <div className={styles.Information}>
          <Link
            to={`/product/${product.shopifyProductId}`}
            className={styles.Title}
          >
            {productname}
          </Link>

          {editable && (
            <div className={styles.EditRemoveGroup}>
              {this.stepperComponent(product, { isEditing, metadata })}
              <Button
                className={removeClasses}
                style={ButtonStyle.Link}
                onClick={() => {
                  if (!isEditing) {
                    onEditProduct(product, 0);
                  }

                  product.delta = product.quantityRecommended;
                  handleGtmEvent('remove_from_cart', {
                    context: this.context,
                    products: [product],
                    metadata,
                  });
                }}
                iconComponent={<TrashIcon />}
              />
            </div>
          )}

          <div className={styles.Detailed}>
            {this.quantityComponent(
              quantityPurchased,
              quantityRecommended,
              editable,
              disabled
            )}
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { products, editable, disabled, className, metadata } = this.props;
    if (!products) return '';

    const componentClasses = classNames(styles.Products, {
      [className]: className,
    });

    return (
      <div className={styles.Products}>
        {products.map((product) =>
          this.singleProductComponent(product, editable, disabled, metadata)
        )}
      </div>
    );
  }
}
//------------------------------------------------------------------------------
// Export ----------------------------------------------------------------------
export default withTranslation()(Products);

Products.contextType = StoreConfigContext;
